import {
  entity,
  relationship,
  JsonapiEntity,
  OneUnresolvedIdentifierOr,
  ResourceIdentifier,
} from 'jsonapi-transformers';

import { RoleRecord } from './role-record';
import { UserRecord } from './user-record';

@entity({ type: 'user_constraints' })
export class UserConstraint extends JsonapiEntity {
  @relationship({ allowUnresolvedIdentifiers: true })
  user: OneUnresolvedIdentifierOr<UserRecord>;
  @relationship({ allowUnresolvedIdentifiers: true })
  role: OneUnresolvedIdentifierOr<RoleRecord>;
  @relationship({ allowUnresolvedIdentifiers: true })
  applies_to: OneUnresolvedIdentifierOr<ResourceIdentifier>;
}
